import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';
import { NoteTypeModel } from './NoteTypeModel';

export interface IPetNoteModel extends IModel {
  petNoteId: number;
  petId: number;
  noteTypeId: number;
  noteType: NoteTypeModel;
  notes: string;
  createdUserTitle: string;
  createdUserFirstName: string;
  createdUserLastName: string;
  dateCreated: string;
}

export class PetNoteModel extends Model implements ModelRecord<IPetNoteModel> {
  petNoteId: number;
  petId: number;
  noteTypeId: number;
  noteType: NoteTypeModel;
  notes: string;
  createdUserTitle: string;
  createdUserFirstName: string;
  createdUserLastName: string;
  dateCreated: string;

  constructor(params?: Partial<IPetNoteModel>) {
    super(params);
    this.petNoteId = defaultTo(params?.petNoteId, 0);
    this.petId = defaultTo(params?.petId, 0);
    this.noteTypeId = defaultTo(params?.noteTypeId, 0);
    this.noteType = params?.noteType
      ? new NoteTypeModel(params?.noteType)
      : new NoteTypeModel();
    this.notes = defaultTo(params?.notes, '');
    this.createdUserTitle = defaultTo(params?.createdUserTitle, '');
    this.createdUserFirstName = defaultTo(params?.createdUserFirstName, '');
    this.createdUserLastName = defaultTo(params?.createdUserLastName, '');
    this.dateCreated = defaultTo(params?.dateCreated, '');
  }
}
